import { useState, useEffect } from 'react';
import ShoppingCentersApi from 'libs/api/shoppingCenters';
import { mapApiVacancyToUi } from './utils';

const shoppingCentersApi = new ShoppingCentersApi();

/**
 * Fetches vacancies for the given shopping center code.
 * @param {string | undefined} shoppingCenterCode - Route param (e.g. 'sov', 'tov')
 * @returns {{ vacancies: Array, loading: boolean }}
 */
export function useVacancies(shoppingCenterCode) {
  const [vacancies, setVacancies] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const code = shoppingCenterCode?.toUpperCase();
    if (!code) {
      setVacancies([]);
      setLoading(false);
      return;
    }

    setLoading(true);
    shoppingCentersApi
      .getVacancies(code)
      .then((res) => {
        const list = res?.data?.vacancies ?? [];
        setVacancies(list.map(mapApiVacancyToUi));
      })
      .catch(() => setVacancies([]))
      .finally(() => setLoading(false));
  }, [shoppingCenterCode]);

  return { vacancies, loading };
}
